import axios from 'axios';
import { API_URL } from '../../config/system/systemConfig';
import { SearchCriteriaModel } from '../../models/platform/searchCriteriaModel';
import { SearchesModel } from '../../models/platform/searchesModel';
import { ResponseSuccessModel } from '../../models/system/responseSuccessModel';
import authHeader from '../../utils/authHeaderUtils';
import { handleAxiosError } from '../../utils/errorUtils';

class SearchSessionApi {

    async executeUnifiedSearch(search_execution_id: string, search: SearchesModel) {
        try {
            const response = await axios.post(`${API_URL}/api/search-sessions/execute`, { search_execution_id, search },
                {
                    headers: authHeader(),
                });
            return response.data;
        } catch (error) {
            return handleAxiosError(error);
        }
    }

    async initiateSearchSession(search: SearchesModel) {
        try {
            const response = await axios.post(`${API_URL}/api/search-sessions/initiate`, { search },
                {
                    headers: authHeader(),
                });
            return response.data;
        } catch (error) {
            return handleAxiosError(error);
        }
    }

}

const searchSessionApi = new SearchSessionApi();
export default searchSessionApi;
